import {Brick, registerBrick, Service} from 'olympe';
import {SUBMIT_PR_SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateSubmitPRSharedMemory.brick';

/**
 * This brick deletes entries from the PRs being submitted Set by publishing an event
 * to shared memory with the appropriate PR tag.
 */
export default class DeleteFromPRsBeingSubmitted extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pRTag
     * @param {function()} forwardEvent
     */
    update($, [prTag], [forwardEvent]) {
        Service.publish('submitPRSharedMemory', {topic: SUBMIT_PR_SHARED_MEMORY_TOPICS.PRS_BEING_SUBMITTED_DELETE, prTag})
            .then(forwardEvent);
    }
}

registerBrick('0197c5d8b48fb7423df6', DeleteFromPRsBeingSubmitted);
